<header mat-dialog-title>
    <div *ngIf="evento$ | async as evento" class="dialog-header">
        <h3 class="mat-h2" i18n="@@retroalimentacion">Retroalimentación<span
            class="glm-modal-subtitle">{{evento.nombre}}</span>
        <span class="modal-sub-subtitle"><strong>Alumno:</strong> {{alumno.apellidosNombres}}</span></h3>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
</header>
<mat-dialog-content class="modal-central-container" style="height: calc(100% - 192px);">
    <div class="">
        <glm-comentarios *ngIf="fechas$ | async as fechas" [comentarios]="comentarios" [targetID]="commentTargetID"
          [textoPlaceHolder]="'Recuerde añadir información no presente en la rúbrica sobre el logro de la meta y recomendaciones de mejora.'"
          [allowCreate]="true" [origen]="'unidadeventoalumno'" [fechas]=fechas></glm-comentarios>
    </div>
</mat-dialog-content>
<!-- 
<mat-dialog-actions>
    <button style="margin-right: 4px;" mat-raised-button color="primary" mat-dialog-close i18n="@@cerrar">Cerrar</button>
</mat-dialog-actions> 
-->
